import { createSelector, createSlice } from '@reduxjs/toolkit';

const defaultFilters = {
    province: '',
    city: '',
    skills: [],
    subSkills: [],
    approval: 'approved',
    onboardingStep: '',
    postalCode: '',
    radius: '3.10686',
    search: '',
    freeInFuture: false,
};

const contractorMapSlice = createSlice({
    initialState: {
        contractors: null,
        isLoading: false,
        selectedContractorId: null,
        filters: { ...defaultFilters },
    },
    name: 'contractorMap',
    reducers: {
        fetchContractors: state => {
            state.isLoading = true;
        },
        contractorsFetched: (state, { payload }) => {
            state.contractors = payload;
            state.isLoading = false;
        },
        contractorsFetchFailed: state => {
            state.isLoading = false;
        },
        setContractorMapFilters: (state, { payload }) => {
            state.filters = { ...state.filters, ...payload };
        },
        resetContractorMapFilters: state => {
            state.filters = { ...defaultFilters };
        },
        selectContractor: (state, { payload }) => {
            state.selectedContractorId = payload;
        },
        clearContractors: state => {
            state.contractors = null;
            state.selectedContractorId = null;
            state.filters = { ...defaultFilters };
        },
    },
});

const getSelf = state => state.contractorMap;

export const getContractors = createSelector(
    getSelf,
    state => state.contractors,
);
export const getContractorMapFilters = createSelector(
    getSelf,
    state => state.filters,
);
export const isLoadingContractors = createSelector(
    getSelf,
    state => state.isLoading,
);
export const getSelectedContractorId = createSelector(
    getSelf,
    state => state.selectedContractorId,
);

export const {
    fetchContractors,
    contractorsFetched,
    contractorsFetchFailed,
    setContractorMapFilters,
    resetContractorMapFilters,
    selectContractor,
    clearContractors,
} = contractorMapSlice.actions;

export default contractorMapSlice.reducer;
